/**
 * Custom hook untuk mengambil detail bank berdasarkan ID
 * 
 * API Endpoint: GET `/api/property-bank/:id`
 * API Version: 3.0
 * 
 * @param {string} id - ID dari bank yang ingin diambil
 * @returns {object} - Return value berupa object dengan key `data`, `isLoading`, dan `error`.
 * @example
 * const { data, isLoading, error } = useShowBank({ id: '1' });
 */


import { useQuery } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { ShowBankResponseSchema } from "../response/ShowBankResponse";

interface ShowBankProps {
    id?: string;
}

const useShowBank = ({ id }: ShowBankProps) => {
    return useQuery({
        queryKey: ['banks', id],
        queryFn: async () => {
            try {
                const response = await privateApi.get(`/v3/property-bank/${id}`);

                // Validasi response
                const validationResult = ShowBankResponseSchema.safeParse(response.data);
                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Invalid bank data format");
                }
                return validationResult.data;
            } catch (error) {
                console.error(`Failed to fetch bank`, error);
                throw error;
            }
        },
        enabled: !!id,
        retry: import.meta.env.VITE_MAX_RETRY,
        refetchOnWindowFocus: false,
    });
};

export default useShowBank;